module.exports = __webpack_public_path__ + "static/media/logo_catalog_interattivo.26d23928.svg";